export const SUPPLIER_LIST_ACTION = "SUPPLIER_LIST_ACTION";
export const SUPPLIER_LIST_SUCCESS = "SUPPLIER_LIST_SUCCESS";

export const SUPPLIER_PRODUCT_GENERATE_ACTION = "SUPPLIER_PRODUCT_GENERATE_ACTION";
export const SUPPLIER_PRODUCT_GENERATE_SUCCESS = "SUPPLIER_PRODUCT_GENERATE_SUCCESS";

export const SUPPLIER_LIST_ALL_ACTION = "SUPPLIER_LIST_ALL_ACTION";
export const SUPPLIER_LIST_ALL_SUCCESS = "SUPPLIER_LIST_ALL_SUCCESS";

export const SUPPLIER_SELECT_LIST_ACTION = "SUPPLIER_SELECT_LIST_ACTION";
export const SUPPLIER_SELECT_LIST_SUCCESS = "SUPPLIER_SELECT_LIST_SUCCESS";

export const SUPPLIER_GET_DETAIL_ACTION = "SUPPLIER_GET_DETAIL_ACTION";
export const SUPPLIER_GET_DETAIL_SUCCESS = "SUPPLIER_GET_DETAIL_SUCCESS";

export const SUPPLIER_CREATE_ACTION = "SUPPLIER_CREATE_ACTION";
export const SUPPLIER_CREATE_SUCCESS = "SUPPLIER_CREATE_SUCCESS";

export const SUPPLIER_DELETE_ACTION = "SUPPLIER_DELETE_ACTION";
export const SUPPLIER_DELETE_SUCCESS = "SUPPLIER_DELETE_SUCCESS";

export const SUPPLIER_UPDATE_ACTION = "SUPPLIER_UPDATE_ACTION";
export const SUPPLIER_UPDATE_SUCCESS = "SUPPLIER_UPDATE_SUCCESS";

export const SUPPLIER_GET_DETAIL_FAQs_ACTION = "SUPPLIER_GET_DETAIL_FAQS_ACTION";
export const SUPPLIER_GET_DETAIL_FAQS_SUCCESS = "SUPPLIER_GET_DETAIL_FAQS_SUCCESS";

export const SUPPLIER_CREATE_FAQS_ACTION = "SUPPLIER_CREATE_FAQS_ACTION";
export const SUPPLIER_CREATE_FAQS_SUCCESS = "SUPPLIER_CREATE_FAQS_SUCCESS";

export const SUPPLIER_DELETE_FAQS_ACTION = "SUPPLIER_DELETE_FAQS_ACTION";
export const SUPPLIER_DELETE_FAQS_SUCCESS = "SUPPLIER_DELETE_FAQS_SUCCESS";

export const SUPPLIER_FAIL = "SUPPLIER_FAIL";

export const SUPPLIER_PRODUCT_LIST_ACTION = "SUPPLIER_PRODUCT_LIST_ACTION";
export const SUPPLIER_PRODUCT_LIST_SUCCESS = "SUPPLIER_PRODUCT_LIST_SUCCESS";

export const SUPPLIER_PRODUCT_GET_DETAIL_ACTION = "SUPPLIER_PRODUCT_GET_DETAIL_ACTION";
export const SUPPLIER_PRODUCT_GET_DETAIL_SUCCESS = "SUPPLIER_PRODUCT_GET_DETAIL_SUCCESS";

export const SUPPLIER_PRODUCT_LIST_ALL_ACTION = "SUPPLIER_PRODUCT_LIST_ALL_ACTION";
export const SUPPLIER_PRODUCT_LIST_ALL_SUCCESS = "SUPPLIER_PRODUCT_LIST_ALL_SUCCESS";

export const SUPPLIER_PRODUCT_CREATE_ACTION = "SUPPLIER_PRODUCT_CREATE_ACTION";
export const SUPPLIER_PRODUCT_CREATE_SUCCESS = "SUPPLIER_PRODUCT_CREATE_SUCCESS";

export const SUPPLIER_PRODUCT_DELETE_ACTION = "SUPPLIER_PRODUCT_DELETE_ACTION";
export const SUPPLIER_PRODUCT_DELETE_SUCCESS = "SUPPLIER_PRODUCT_DELETE_SUCCESS";

export const SUPPLIER_PRODUCT_UPDATE_ACTION = "SUPPLIER_PRODUCT_UPDATE_ACTION";
export const SUPPLIER_PRODUCT_UPDATE_SUCCESS = "SUPPLIER_PRODUCT_UPDATE_SUCCESS";

export const SUPPLIER_PRODUCT_USAGE_PLAN_DETAIL_ACTION = "SUPPLIER_PRODUCT_USAGE_PLAN_DETAIL_ACTION";
export const SUPPLIER_PRODUCT_USAGE_PLAN_DETAIL_SUCCESS = "SUPPLIER_PRODUCT_USAGE_PLAN_DETAIL_SUCCESS";

export const SUPPLIER_VINWONDER_SITES_ACTION = "SUPPLIER_VINWONDER_SITES_ACTION";
export const SUPPLIER_VINWONDER_SITES_SUCCESS = "SUPPLIER_VINWONDER_SITES_SUCCESS";

export const SUPPLIER_VINWONDER_TYPES_ACTION = "SUPPLIER_VINWONDER_TYPES_ACTION";
export const SUPPLIER_VINWONDER_TYPES_SUCCESS = "SUPPLIER_VINWONDER_TYPES_SUCCESS";

export const SUPPLIER_VINWONDER_REFIDS_ACTION = "SUPPLIER_VINWONDER_REFIDS_ACTION";
export const SUPPLIER_VINWONDER_REFIDS_SUCCESS = "SUPPLIER_VINWONDER_REFIDS_SUCCESS";

export const SUPPLIER_CREATE_TRANSLATE_ACTION = "SUPPLIER_CREATE_TRANSLATE_ACTION";
export const SUPPLIER_CREATE_TRANSLATE_SUCCESS = "SUPPLIER_CREATE_TRANSLATE_SUCCESS";

export const SUPPLIER_UPDATE_TRANSLATE_ACTION = "SUPPLIER_UPDATE_TRANSLATE_ACTION";
export const SUPPLIER_UPDATE_TRANSLATE_SUCCESS = "SUPPLIER_UPDATE_TRANSLATE_SUCCESS";

export const SUPPLIER_DELETE_TRANSLATE_ACTION = "SUPPLIER_DELETE_TRANSLATE_ACTION";
export const SUPPLIER_DELETE_TRANSLATE_SUCCESS = "SUPPLIER_DELETE_TRANSLATE_SUCCESS";
